import { render, staticRenderFns } from "./NewsBadge.vue?vue&type=template&id=60126393&scoped=true"
import script from "./NewsBadge.vue?vue&type=script&lang=js"
export * from "./NewsBadge.vue?vue&type=script&lang=js"
import style0 from "./NewsBadge.vue?vue&type=style&index=0&id=60126393&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60126393",
  null
  
)

export default component.exports